import { observer } from 'mobx-react';
import * as React from 'react';
import InviteParticipantStore from '../../../../../Store';
import { SelectParticipantsState } from '../../../../../Store/Types';
import LicenseMessage from '../../../../../../../../../../../../LicenseMessage';
import SelectedUsers from '../../../../../../../../../../../../SelectedUsers';
import NextButton from '../../../../../../../../../../../../NextButton';

export interface Props {
  store: InviteParticipantStore;
  state: SelectParticipantsState;
}

const Participants: React.FC<Props> = ({ store, state }) => (
  <>
    <div className="max-h-60 h-60 text-sm overflow-y-auto mb-3">
      <SelectedUsers
        newGroupsAndParticipants={state.newGroupsAndParticipants}
        removeGroup={store.removeGroup}
        removeParticipant={store.removeParticipant}
      />
    </div>
    <LicenseMessage
      activationsRemaining={state.activationsRemaining}
      title={state.publicName}
      newLicenseAllocations={state.newLicenseAllocations}
      allocatedLicenses={state.allocatedLicenses}
    />
    <NextButton
      inviting={store.inviting}
      submit={store.submit}
      activationsRemaining={state.activationsRemaining}
    />
  </>
);

export default observer(Participants);
